import React, { FunctionComponent } from 'react';
import { ApolloQueryResult, ApolloClient, InMemoryCache } from '@apollo/client';

import audioIcon from '@app/assets/images/audioIcon.svg';
import pauseIconSvg from '@app/assets/images/pauseIcon.svg';
import { AudioPlayerActions } from '@app/actions/audioPlayer';

import GET_MEDIA_ITEM_QUERY from '../ProductFinder/getMedia.query';
import { getMedia } from '../ProductFinder/__generated__/getMedia';
import AE from '../AudioPlayer/AudioEngine';
import MediaIcon from '../MediaIcon';

export interface AudioPlayerTriggerProps {
  audioId: number | string;
  audioPlayer;
  dispatchers: AudioPlayerActions;
  client: ApolloClient<InMemoryCache>;
}

const AudioPlayerTrigger: FunctionComponent<AudioPlayerTriggerProps> = ({
  audioId,
  audioPlayer,
  client,
  dispatchers,
}) => {
  const {
    playAudioPlayer,
    pauseAudioPlayer,
    resetAudioPlayer,
    setId,
    loadAudio,
    setData,
  } = dispatchers;

  const isAudioPlayerTarget = audioPlayer.id === audioId;
  const isAudioPlaying = isAudioPlayerTarget && audioPlayer.isPlaying;
  const isAudioLoading = isAudioPlayerTarget && audioPlayer.isAudioLoading;

  const getMedia = async (
    id: string | number
  ): Promise<ApolloQueryResult<getMedia>> =>
    client.query({
      query: GET_MEDIA_ITEM_QUERY,
      variables: { id: Number(id) },
    });

  const onClick = async (): Promise<void | null> => {
    try {
      if (isAudioPlaying) {
        AE.pause();
        pauseAudioPlayer();
      } else if (isAudioPlayerTarget) {
        AE.play();
        playAudioPlayer();
      } else {
        AE.reset();
        resetAudioPlayer();
        setId(audioId);
        loadAudio();
        const queryResult = await getMedia(audioId);
        setData(queryResult.data.media);
      }
      return null;
    } catch (err) {
      return null;
    }
  };

  return (
    <MediaIcon
      isLoading={isAudioLoading}
      onClick={onClick}
      svg={isAudioPlaying ? pauseIconSvg : audioIcon}
      altText="play audio"
    />
  );
};

export default AudioPlayerTrigger;
